import { createApp } from "vue";
import App from "./App.vue";
import "vant/es/toast/style";
import "vant/es/dialog/style";
import "vant/es/image-preview/style";
import router from "./router";
import store from "./assets/img/store";
import "amfe-flexible";
import "@/assets/global.css";
import "vant/lib/index.css";
import vue3videoPlay from 'vue3-video-play' // 引入组件
import 'vue3-video-play/dist/style.css' // 引入css
createApp(App).use(store).use(router).use(vue3videoPlay).mount("#app");

